import { ActionTypes } from 'redux/actions/actionType';

// types
import { 
    ContainersState,
    SetContainersAction,
    ContainerState,
    SetContainerAction,
    WarehousesState,
    SetWarehousesAction,
    ContainerReservationsState,
    SetContainerReservationsAction,
} from 'types/typesRedux';

const containersState: ContainersState = {
    containers: [],
    totalCount: 0,
};

export const containersReducer = (state= containersState, { type, payload }: SetContainersAction ) => {
    switch ( type ) {
        case ActionTypes.SET_CONTAINERS:
            return {
                ...state,
                containers: payload.containers,
                totalCount: payload.totalCount,
            };
        default:
            return state;
    }
};


const containerState: ContainerState = {
    container: [],
};

export const containerReducer = (state= containerState, { type, payload }: SetContainerAction ) => {
    switch ( type ) {
        case ActionTypes.SET_CONTAINER:
            return { ...state, container: payload };
        default:
            return state;
    }
};

const warehousesState: WarehousesState = {
    warehouses: [],
};

export const warehousesReducer = (state= warehousesState, { type, payload }: SetWarehousesAction ) => {
    switch ( type ) {
        case ActionTypes.SET_WAREHOUSES:
            return { ...state, warehouses: payload };
        default:
            return state;
    }
};

const containerReservationsState: ContainerReservationsState = {
    containerReservations: [],
    totalCount: 0,
};

export const containerReservationsReducer = (state= containerReservationsState, { type, payload }: SetContainerReservationsAction ) => {
    switch ( type ) {
        case ActionTypes.SET_CONTAINER_RESERVATIONS:
            return {
                ...state,
                containerReservations: payload.containerReservations,
                totalCount: payload.totalCount,
            };
        default:
            return state;
    }
};
